export default {
  listOutlet: [],
  allOutlets: null,
  loading: true
}
